export default __webpack_public_path__ + "static/media/iron.e5ec1f40.png";